import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNews = () => {
  return (
    <g>
      <path d="m4.55 1 10.402.017c.54.001.985.41 1.042.936l.006.114V12.25a2.75 2.75 0 0 1-2.582 2.745L13.25 15H3.499l-.001-.002L2.25 15A2.25 2.25 0 0 1 0 12.75V5.298a.75.75 0 0 1 .747-.75l2.751-.012V2.05c0-.54.41-.986.937-1.043L4.549 1zm.448 1.501V13.5h8.252a1.25 1.25 0 0 0 1.225-.998l.019-.124.006-.128V2.516l-9.502-.015zm-1.5 3.533L1.5 6.045v6.705l.007.102a.75.75 0 0 0 .743.648l1.248-.002V6.034zM12.254 10c.378 0 .69.28.74.645l.006.11a.746.746 0 0 1-.746.745H7.246a.746.746 0 0 1-.74-.645l-.006-.11c0-.411.334-.745.746-.745h5.008zm0-3c.378 0 .69.28.74.645l.006.11a.746.746 0 0 1-.746.745H7.246a.746.746 0 0 1-.74-.645l-.006-.11c0-.411.334-.745.746-.745h5.008zm0-3c.378 0 .69.28.74.645l.006.11a.746.746 0 0 1-.746.745H7.246a.746.746 0 0 1-.74-.645l-.006-.11c0-.411.334-.745.746-.745h5.008z" />
    </g>
  );
};

export default withIcon(IconNews);
